export const environment = {
    production: false,
    appUpdateEnabled: true,
    environmentName: 'test',
    apiUrl: 'https://test-portal-api.captire.com',
};
